<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <user-table @useredit="UserEdit" />
      </a-col>
    </a-row>

    <!-- <el-drawer
      :title="drawerTitle"
      :visible.sync="EditModelVisible"
      :size="drwaerSize"
      :show-close=true
    >
      <user-edit />
    </el-drawer> -->
    <a-modal
      v-model:open="EditModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <user-edit :userMod="selUserMod" @EditUserComHandle="EditUserCom" @CancleEdit="CancleEdit"/>
    </a-modal>
  </div>
</template>

<script>
import { UserTable, UserEdit } from "./components/index.js";

export default {
  components: {
    UserTable,
    UserEdit,
  },
  data() {
    return {
      EditModelVisible: false,
      amodelTitle: "用户编辑",
      isMobile: false,
      selUserMod: {
        id: "",
        userName: "",
        userPhone: "",
      },
    };
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  created() {
    this.checkIfMobile();
  },
  methods: {
    UserEdit(userMod) {
      this.amodelTitle = userMod.id == "" ? "用户添加" : "用户编辑";
      this.selUserMod = Object.assign(userMod);
      console.log(this.selUserMod);
      this.EditModelVisible = true;
    },
    checkIfMobile() {
      // 通常以768px作为移动设备的断点
      this.isMobile = window.innerWidth <= 768;
    },
    EditUserCom(newmod){
      this.EditModelVisible = false;
    },
    CancleEdit(){
      this.selUserMod = {id:"",userName:"",userPhone:""}
      this.EditModelVisible = false;
    }
  },
};
</script>

<style lang="scss">
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
</style>